module.exports = __webpack_public_path__ + "img/chivas_ferrari_mobile_bg.c5eb9e14.png";